import {Injectable} from '@angular/core';
import {ExamFormConverter} from "../../../api/converter/examForm.converter";
import {ExamFormDataService} from "./examFormData.service";
import {ExamFormModel} from "../../../api/model/exam-form.model";
import {
    AbstractDataServiceDtoAdapter
} from "../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter";

@Injectable()
export class ExamFormDataServiceAdapter extends AbstractDataServiceDtoAdapter<ExamFormModel, ExamFormConverter> {
    constructor(dataService: ExamFormDataService, converter: ExamFormConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): ExamFormModel {
        return new ExamFormModel();
    }

}
